export default __webpack_public_path__ + "static/media/temps.9a532968.svg";